import { render, staticRenderFns } from "./Part5.vue?vue&type=template&id=98b8daa0&scoped=true"
import script from "./Part5.vue?vue&type=script&lang=js"
export * from "./Part5.vue?vue&type=script&lang=js"
import style0 from "./Part5.vue?vue&type=style&index=0&id=98b8daa0&prod&lang=scss&scoped=true"
import style1 from "./Part5.vue?vue&type=style&index=1&id=98b8daa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b8daa0",
  null
  
)

export default component.exports